import { render } from "./LessonModule.vue?vue&type=template&id=8496a0e6"
import script from "./LessonModule.vue?vue&type=script&lang=js"
export * from "./LessonModule.vue?vue&type=script&lang=js"

import "./LessonModule.vue?vue&type=style&index=0&id=8496a0e6&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__